import React from 'react'
import { css, useTheme } from '@emotion/react'
import { SectionTitle } from '../base-ui'

function WidgetList({
    widget,
    filterItem = ({ news }) => news,
    itemRender,
    divider,
    columns = 1,
    showItem,
    className,
    orientation = 'default',
    gap = '1px',
    title,
    titleSetting = {},
    noStyle = false,
    listStyle,
}) {
    if (!showItem) showItem = widget?.limit
    const theme = useTheme()
    const data = widget?.newsList || widget
    const newsListSortFn = (a, b) => a.position - b.position
    const myData = filterItem
        ? data?.sort(newsListSortFn)?.filter(filterItem)?.slice(0, showItem) ??
        []
        : data?.sort(newsListSortFn)?.slice(0, showItem) ?? []

    divider = divider || <div style={{ margin: gap }}></div>
    if (noStyle) return myData.map((item, idx) => (
        React.createElement(itemRender, { post: item, idx, key: idx })
    ))
    const horizentalList = (
        <div className={className}>
            {title && <SectionTitle {...titleSetting} >{title}</SectionTitle>}
            <div
                className="content"
                css={noStyle ? null : css`
                    display: grid;
                    grid-template-columns: repeat(${columns}, minmax(0, 1fr));
                    gap: ${gap};
                    border-radius: ${theme.borderRadius.default};
                    .card-content {
                        display: flex;
                        flex-direction: column;
                    }
                 `}
                style={listStyle}
            >
                {/* , type === 'default' && <Divider gap={gap} />) */}
                {myData.map((item, idx) => (
                    <div key={idx}>
                        {React.createElement(itemRender, { post: item, idx })}
                        {idx < myData.length - 1 && divider}
                    </div>
                ))}
            </div>
        </div>
    )
    return <>{orientation === 'default' && horizentalList}</>
}

export default WidgetList
